import { styled } from '@mui/system';
import { Divider } from '@mui/material';

export const Tooltip = styled('div')(() => ({
  textAlign: 'left',
  minWidth: 150
}));

export const Label = styled('div')(({ theme }) => ({
  display: 'flex',
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  '& p': {
    lineHeight: '26px',
    color: theme.palette.common.white
  }
}));

export const SvgIcon = styled('div')(({ theme }) => ({
  marginRight: 4,
  color: `${theme.palette.common.white} !important`
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  marginTop: 4,
  marginBottom: 4,
  backgroundColor: theme.palette.common.white
}));
